import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { BaseElement } from "../utils/ui-components";
import { SubtitleItem, MediaItem, MediaItemSegment } from "../data/types";
import { playCircleIcon } from "../utils/icons";
import { formatTime } from "../utils/utils";
import { AudioState } from "./audio-player";

@customElement("subtitle-view")
export class SubtitleView extends BaseElement {
    @property()
    subtitle!: SubtitleItem;

    @property()
    item!: MediaItem;

    @property()
    segment!: MediaItemSegment;

    @property()
    onAudioRequest?: (state: AudioState) => void;

    render() {
        const handlePlayClick = () => {
            if (!this.item || !this.segment) {
                console.error("Missing item or segment:", { item: this.item, segment: this.segment });
                return;
            }

            this.onAudioRequest?.({
                item: this.item,
                segment: this.segment,
                subtitle: {
                    text: this.subtitle.text,
                    start: this.subtitle.start,
                },
            });
        };

        const absoluteTime = this.subtitle.start + (this.segment?.offset || 0);

        return html`
            <div class="flex items-center gap-2 py-1.5">
                <div class="flex items-center gap-2">
                    <button
                        @click=${handlePlayClick}
                        class="p-1.5 rounded-full hover:bg-gray-100 text-blue-600 hover:text-blue-700 transition-colors"
                    >
                        <i class="w-5 h-5 icon">${playCircleIcon}</i>
                    </button>
                    <span class="text-xs text-gray-400 font-mono">${formatTime(absoluteTime)}</span>
                </div>
                <div class="flex-1 min-w-0 flex items-center">
                    ${this.subtitle.speaker ? html`<span class="text-xs font-medium text-gray-500 mr-1">${this.subtitle.speaker}:</span>` : ""}
                    <span class="text-sm text-gray-600 [&_mark]:leading-normal [&_mark]:bg-yellow-200">${unsafeHTML(this.subtitle.text)}</span>
                </div>
            </div>
        `;
    }
}
